"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestSQLOrder = void 0;
var RestSQLOrder = /** @class */function () {
  function RestSQLOrder() {}
  RestSQLOrder.stringify = function (sqlOrder) {
    this.validateStringify(sqlOrder);
    var orderString = '';
    sqlOrder.forEach(function (data, index) {
      var _a = data,
        property = _a[0],
        order = _a[1];
      orderString += "".concat(property.trim(), ":").concat(order);
      if (index !== sqlOrder.length - 1) {
        orderString += ';';
      }
    });
    return orderString;
  };
  RestSQLOrder.parse = function (orderString) {
    this.validateParse(orderString);
    var order = [];
    var level1 = orderString.split(';');
    level1.forEach(function (level) {
      var _a = level.split(':'),
        property = _a[0],
        sort = _a[1];
      order.push([property, sort]);
    });
    return order;
  };
  RestSQLOrder.validateStringify = function (sqlOrder) {
    if (!Array.isArray(sqlOrder)) {
      throw new Error("Stringify Error! sqlOrder must be Array<[string, 'ASC' | 'DESC']>! value = `".concat(String(sqlOrder), "`"));
    }
    sqlOrder.forEach(function (data, index) {
      if (!Array.isArray(data)) {
        throw new Error("Stringify Error! sqlOrder[".concat(index, "] must be [string, 'ASC' | 'DESC']! value = `").concat(String(data), "`"));
      }
      var property = data[0],
        sort = data[1];
      if (typeof property !== 'string') {
        throw new Error("Stringify Error! sqlOrder[".concat(index, "][0] must be a string! value = `").concat(String(property), "`"));
      }
      if (property.trim() === '') {
        throw new Error("Stringify Error! sqlOrder[".concat(index, "][0] should not be empty! value = `").concat(property, "`"));
      }
      if (!['ASC', 'DESC'].includes(String(sort))) {
        throw new Error("Stringify Error! sqlOrder[".concat(index, "][1] must be 'ASC' | 'DESC'! value = `").concat(String(sort), "`"));
      }
    });
  };
  RestSQLOrder.validateParse = function (orderString) {
    if (typeof orderString !== 'string') {
      throw new Error("Parse Error! orderString must be a string! value = `".concat(orderString, "`"));
    }
    var level1 = orderString.split(';');
    level1.forEach(function (level) {
      var level2 = level.split(':');
      if (level2.length === 1) {
        throw new Error("Parse Error! Order must be `property:('ASC' | 'DESC')`! value = `".concat(orderString, "`"));
      }
      var _a = level.split(':'),
        property = _a[0],
        sort = _a[1];
      if (property.trim() === '') {
        throw new Error("Parse Error! Property should not be empty! value = `".concat(property, "`"));
      }
      if (!['ASC', 'DESC'].includes(String(sort))) {
        throw new Error("Parse Error! Sort must be 'ASC' | 'DESC'! value = `".concat(String(sort), "`"));
      }
    });
  };
  return RestSQLOrder;
}();
exports.RestSQLOrder = RestSQLOrder;
